import { globals } from './globals';
import { utils } from './utils';
import { Shopify } from './shopify';

// Expose variables and functions to Alpine
window.blueprint = function () {
  return {
    // Spread objects
    ...globals,
    ...utils,
    ...Shopify,
  };
};
